export default __webpack_public_path__ + "static/media/risenchrist.03602838.jpg";